import { ChangeDetectionStrategy, Component } from '@angular/core';
import { first } from 'rxjs/operators';

import { arrowRightIcon } from '../../../../../../icons';
import { CheckoutFlowService } from '../../../../../checkout/checkout-flow.service';
import { CheckoutService } from '../../../../../checkout/checkout.service';

@Component({
    selector: 'app-checkout-step-payment-cash',
    template: `
        <section class="flow-step__section-block">
            <header class="flow-step__section-block-header">
                <h5>{{ 'checkout.payment_step____cash_tab____content_headline' | translate }}</h5>
                <p>{{ 'checkout.payment_step____cash_tab____content_description' | translate }}</p>
            </header>

            <app-checkout-price-calculation-summary
                [loanAmount]="loanAmount"
                [outstandingDebt]="outstandingDebt"
                (handleOutstandingDebt)="handleDebt($event)"
                [priceTranslation]="'checkout.payment_step____cash_tab____calculated_price' | translate"
            ></app-checkout-price-calculation-summary>
        </section>

        <section class="center grid-spacing-normal">
            <app-button
                *ngIf="!(checkoutFlowService.atFlowStart$ | async)"
                buttonClass="button--tertiary button--has-spacing button--has-bottom-spacing"
                [title]="'checkout.button____go_back_to_previous_step' | translate"
                (handleClick)="checkoutFlowService.prevStep()"
            ></app-button>
            <app-button
                buttonClass="button--primary button--has-spacing button--has-bottom-spacing"
                [title]="'checkout.button____choose_and_proceed' | translate"
                (handleClick)="handleSubmit()"
                [loading]="!!(checkoutService.isCheckoutLoading$ | async)"
            >
                <i aria-hidden="true" class="button__icon">${arrowRightIcon}</i>
            </app-button>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutStepPaymentCashComponent {
    loanAmount: number;
    outstandingDebt = 0;
    constructor(public checkoutService: CheckoutService, public checkoutFlowService: CheckoutFlowService) {
        this.calcPrice();
    }

    handleDebt(value: string) {
        const val = parseInt(value);
        const debtValue = isNaN(val) ? 0 : val;

        this.calcPrice(debtValue);
        this.outstandingDebt = debtValue;
    }

    calcPrice(outstandingDebt?: number) {
        this.checkoutService
            .getCheckoutData()
            .pipe(first())
            .subscribe(({ product, exchangeCar }) => {
                this.loanAmount = (product?.grossPrice || 0) - (exchangeCar?.price || 0) + (outstandingDebt || 0);
            });
    }

    handleSubmit() {
        this.checkoutService.setCashPayment();
    }
}
